export const Commons = () => {

    const getUserAgent = () => {
        if (typeof navigator !== 'undefined' && navigator.userAgent) {
            return navigator.userAgent;
        }
        return 'User agent não disponível';
    };

    const isLauncherAgent = () => {
        const agent = getUserAgent();
        return agent.includes("Splush");
    };

    return {
        getUserAgent,
        isLauncherAgent
    }
};
